
import ReCAPTCHA from "react-google-recaptcha"
import { useState, useRef, useEffect } from "react"
import { Radio, message  } from "antd"
import { useSendRepAffiliationSummaryEmailMutation } from "./rasApiSlice"
import { showSpinner, hideSpinner } from "../componentSlice"
import { useDispatch } from "react-redux"
import logo from "./logo.png"

import './ras.css'

const Ras = () => {

    const dispatch = useDispatch()
    const [recruiter, setRecruiter] = useState(null)
    const [onboardingFirm, setOnboardingFirm] = useState(null)
    const [targetTransitionDate, setTargetTransitionDate] = useState(null)
    const [firmName, setFirmName] = useState(null)
    const [repInformation, setRepInformation] = useState([{}])
    const [captchaToken, setCaptchaToken] = useState(null)
    const [errorMessage, setErrorMessage] = useState(null)
    const captchaRef = useRef(null)

    const [ sendRepAffiliationSummaryEmail,  {
            isLoading,
            isSuccess
    }] = useSendRepAffiliationSummaryEmailMutation()

    useEffect(() => {
        if(isLoading) {
            dispatch(showSpinner())
        } else{
            dispatch(hideSpinner())
        }
    }, [isLoading])

    useEffect(() => {
        if(isSuccess) {
            alertMessage("Summary Sent!")
        }
    }, [isSuccess])

    const [messageApi, contextHolder] = message.useMessage()
    
    const alertMessage = (message) => {
        messageApi.success(message)
    }
    
    const onSubmit = async (e) => {
        e.preventDefault();

        if (!captchaToken) {
            return
        }

        try {
            let request = {
                recruiter, 
                onboardingFirm,
                targetTransitionDate,
                firmName,
                repInformation, 
                captcha: captchaToken}

            await sendRepAffiliationSummaryEmail(request).unwrap()
        } catch(err) {
            setErrorMessage(err.data?.message)
        }
    }

    const handleRepInformationChange = (e, index) => {
        setRepInformation(prev =>
            prev.map((item, i) =>
                i === index
                    ? { ...item, [e.name]: e.value }
                    : item
            )
        )
    }

    const handleBookOfBusinessChange = (e, index) => {
        setRepInformation(prev => {
            const updated = [...prev]

            updated[index] = {
                ...updated[index],
                bookOfBusiness: {
                    ...updated[index].bookOfBusiness,
                    [e.name]: e.value
                }
            }

            return updated
        })
    }

    const addAdvisor = (e) => {
         e.preventDefault()

         if(repInformation?.length === 20) {
            return
         }

         setRepInformation((prev) => [...prev, {}])
    }

    const deleteAdvisor = (e) => {
        e.preventDefault()

        if (repInformation.length === 1) {
            return
        }

        setRepInformation(prev => prev.slice(0, -1))
    }

    return (
        <div className="ras">
            {contextHolder}
            <div className="ras-accent" />
            <div className="ras-logo">
                <figure>
                    <img src={logo} width="100" height="100" loading="lazy" alt="about banner" />
                </figure>
            </div>
            <div className="ras-container">
                <div className="ras-header">
                    <h2>Affiliation Summary</h2>
                </div>
                <p className='errorMessage'>{errorMessage}</p>
                <form onSubmit={(e) => onSubmit(e)}>
                    <div className="form-group">
                        <label for="recruiter">Recruiter</label>
                        <input className="inpt" type="recruiter" id="recruiter" name="recruiter" required value={recruiter} onChange={(e) => setRecruiter(e.target.value)} />
                    </div>

                    <div className="affiliate-container">
                        <div className="form-group">
                            <label for="onboardingFirm">Affiliating Broker-Dealer</label>
                            <input className="inpt" type="onboardingFirm" id="onboardingFirm" name="onboardingFirm" required value={onboardingFirm} onChange={(e) => setOnboardingFirm(e.target.value)} />
                        </div>

                        <div className="form-group">
                            <label for="onboardingFirm">Target Transition Date</label>
                            <input className="inpt" type="targetTransitionDate" id="targetTransitionDate" name="targetTransitionDate" required value={targetTransitionDate} onChange={(e) => setTargetTransitionDate(e.target.value)} />
                        </div>
                    </div>
                    

                    <div className="form-group">
                        <label for="firmName">Firm Name</label>
                        <input className="inpt" type="firmName" id="firmName" name="firmName" required value={firmName} onChange={(e) => setFirmName(e.target.value)} />
                    </div>

                    {
                        repInformation?.map((rep, index) => {
                            return (
                                <div className="ras-card">
                                    <div className="ras-card-header">
                                        <h4>Advisor Information</h4>
                                    </div>
                                    <div className="ras-card-body">
                                        <div className="form-group">
                                            <label for="name">Name</label>
                                            <input className="inpt" type="name" id="name" name="name" required value={rep[index]?.name} onChange={(e) => handleRepInformationChange(e.target, index)} />
                                        </div>

                                        <div className="form-group">
                                            <label for="contraFirm">Contra Firm</label>
                                            <input className="inpt" type="contraFirm" id="contraFirm" name="contraFirm" required value={rep[index]?.contraFirm} onChange={(e) => handleRepInformationChange(e.target, index)} />
                                        </div>

                                        <div className="form-group">
                                            <label for="email">Email</label>
                                            <input className="inpt" id="email" name="email" required value={rep[index]?.email} onChange={(e) => handleRepInformationChange(e.target, index)} />
                                        </div>

                                        <div className="form-group">
                                            <label for="phoneNumber">Phone Number</label>
                                            <input className="inpt" type="phoneNumber" id="phoneNumber" name="phoneNumber" required value={rep[index]?.phoneNumber} onChange={(e) => handleRepInformationChange(e.target, index)} />
                                        </div>

                                        <div className="form-group">
                                            <label for="location">Location</label>
                                            <input className="inpt" type="location" id="location" name="location" required value={rep[index]?.location} onChange={(e) => handleRepInformationChange(e.target, index)} />
                                        </div>

                                        <div className="ras-card">
                                            <div className="ras-card-header">
                                                <h4>Book of Business</h4>
                                            </div>
                                            <div className="ras-card-body">
                                                <div className="form-group">
                                                    <label for="advisory">Number of Advisory Accounts</label>
                                                    <input className="inpt" type="number" id="advisory" name="advisory" required value={rep[index]?.bookOfBusiness?.advisory} onChange={(e) => handleBookOfBusinessChange(e.target, index)} />
                                                </div>

                                                <div className="form-group">
                                                    <label for="brokerage">Number of Brokerage Accounts</label>
                                                    <input className="inpt" type="number" id="brokerage" name="brokerage" required value={rep[index]?.bookOfBusiness?.brokerage} onChange={(e) => handleBookOfBusinessChange(e.target, index)} />
                                                </div>

                                                <div className="form-group">
                                                    <label for="direct">Number of Direct Accounts</label>
                                                    <input className="inpt" type="number" id="direct" name="direct" required value={rep[index]?.bookOfBusiness?.direct} onChange={(e) => handleBookOfBusinessChange(e.target, index)} />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <label for="nonCompeteIssues">Non-compete issues?</label>
                                            <Radio.Group
                                                style={{ display: 'flex', gap: 16, paddingBlockStart: 5, paddingLeft: 5 }}
                                                onChange={(e) => handleRepInformationChange({
                                                    name: 'nonCompeteIssues',
                                                    value: e.target.value,
                                                }, index)}
                                                options={[
                                                    { label: 'Yes', value: true }, 
                                                    { label: 'No', value: false }
                                                ]}
                                                defaultValue={true}
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label for="additionalInfo">Relevant additional information</label>
                                            <textarea style={{ width: '100%', height: '120px', resize: 'none' }} className="inpt" type="additionalInformation" id="additionalInformation" name="additionalInformation" value={rep[index]?.additionalInformation} onChange={(e) => handleRepInformationChange(e.target, index)} />
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }

                    <div className="add-remove-advisor-list">
                        <button type="button" onClick={(e) => addAdvisor(e)}>Add</button>
                        {repInformation?.length > 1 && <button type="button" onClick={(e) => deleteAdvisor(e)}>Remove</button>}
                    </div>

                    <div className="captcha">
                        <ReCAPTCHA
                            sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
                            onChange={(token) => setCaptchaToken(token)}
                            ref={captchaRef}
                        />
                    </div>

                    <div className="form-group">
                        <button className="crm-button">Submit</button>
                    </div>
                </form>
            </div>

        </div>
    )
}

export default Ras